import React from 'react';
import InterviewedOn from './InterviewedOn';
import StatusAndRecording from './StatusAndRecording';
import InterviewedBy from './InterviewedBy';
import { GetMeetingScoreCardAPIResponse, MeetingStatus } from 'types';
import { useGetMeetingRecordingByMeetingIdQuery } from 'src/hooks/meeting.hooks';

export type InterviewedByType = {
	interviewerName: string;
	companyName: string;
	companyRole: string;
	linkedinLink?: string | undefined;
	imgUrl?: string | undefined;
};
export type AssessmentCompanyType = {
	meetingTitle: string;
	companyTitle: string;
	position: string;
	companyURL?: string | undefined;
	companyLogo?: string | undefined;
};
export type InterviewedOnType = {
	startTime: string;
	duration: number;
};

interface Props {
	interviewedBy: InterviewedByType;
	interviewedOn: InterviewedOnType;
	status: MeetingStatus | undefined;
	handleViewRecording: () => void;
	meetingScore: number;
	meetingId: string;
	skillScores: GetMeetingScoreCardAPIResponse['allMeetingSkillScores'];
}

const DetailCard = ({
	interviewedBy,
	interviewedOn,
	status,
	handleViewRecording,
	meetingScore,
	meetingId,
	skillScores,
}: Props) => {
	return (
		<>
			<div className="px-4 py-5 bg-white dark:bg-[#1F2A37] rounded-[12px] border dark:border-0">
				<div className="flex gap-8 sm:flex-col sm:gap-7">
					<div className="flex gap-8 sm:justify-between sm:gap-2">
						{/* <InterviewedBy
							title="Interviewed by"
							data={interviewedBy}
							companydata={{
								meetingTitle: '',
								companyTitle: interviewedBy.companyName,
								position: interviewedBy.companyRole,
							}}
						/> */}
						<InterviewedOn data={interviewedOn} />
					</div>

					<div className="grow-2 pl-4 border-l dark:border-[#9E9E9E] border-solid sm:p-0 sm:border-none">
						<StatusAndRecording
							status={status}
							handleViewRecording={handleViewRecording}
							meetingScore={meetingScore}
							meetingId={meetingId}
							skillScores={skillScores}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default DetailCard;
